import React from "react";
import {
  Button,
  Form,
  Input,
  Select,
  message,
  Row,
  Col,
  Radio,
  DatePicker,
  InputNumber,
  Collapse,
} from "antd";
import { evaluationQuestions } from "./evaluationQuestions";

const EmployeeEvaluationRating = ({
  jobUnderstanding,
  jobSkills,
  growth,
  performance,
  accountable,
  commitment,
  integrity,
  collaboration,
  attendance,
  communicationSkills,

  onChangeJobUnderstanding,
  onChangeJobSkills,
  onChangeGrowth,
  onChangePerformance,
  onChangeAccountable,
  onChangeCommitment,
  onChangeIntegrity,
  onChangeCollaboration,
  onChangeAttendance,
  onChangeCommunicationSkills,
  selfEmployeeUserInfo,
}) => {
  const ratingValues = {
    jobKnowledge: jobUnderstanding,
    jobSkills,
    growth,
    performance,
    accountable,
    commitment,
    integrity,
    collaboration,
    punctuality: attendance,
    communication: communicationSkills,
  };

  return (
    <>
      <h5 className="employee-ev-rating ant-drawer-header" style={{}}>
        Ratings
      </h5>
      <Row className="employee-evaluation__rating">
        <Col span={8}></Col>
        <Col span={16}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingRight: "6px",
            }}
          >
            <p>1 = poor</p>
            <p>2 = Fair</p>
            <p>3 = Satisfactory</p>
            <p>4 = Good</p>
            <p>5 = Excellent-</p>
          </div>
        </Col>
      </Row>

      {evaluationQuestions.map((question) => (
        <Form.Item key={question.key}>
          <Form.Item
            className="employee-ev-radioGroup-wrapper"
            name={question.formName}
            label={question.title}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Radio.Group
              value={ratingValues[question.key]}
              onChange={
                question.key === "jobKnowledge"
                  ? onChangeJobUnderstanding
                  : question.key === "jobSkills"
                  ? onChangeJobSkills
                  : question.key === "growth"
                  ? onChangeGrowth
                  : question.key === "performance"
                  ? onChangePerformance
                  : question.key === "accountable"
                  ? onChangeAccountable
                  : question.key === "commitment"
                  ? onChangeCommitment
                  : question.key === "integrity"
                  ? onChangeIntegrity
                  : question.key === "collaboration"
                  ? onChangeCollaboration
                  : question.key === "punctuality"
                  ? onChangeAttendance
                  : onChangeCommunicationSkills
              }
              style={{ width: "100%" }}
              className="employee-ev-radioGroup"
            >
              <Radio value={1} />
              <Radio value={2} />
              <Radio value={3} />
              <Radio value={4} />
              <Radio value={5} />
            </Radio.Group>
          </Form.Item>
          <label className="employee-ev-radioGroup-wrapper">
            {question.description} {question.weight}
          </label>
          <Form.Item
            className="employe-ev-form"
            name={question.commentName}
            label="Comments"
            wrapperCol={{ span: 24 }}
            labelCol={{ span: 24 }}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form.Item>
      ))}

      {!selfEmployeeUserInfo && (
        <Form.Item
          className="employe-ev-form"
          name="majorStrengthComment"
          label="Major Strength"
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      )}
      {!selfEmployeeUserInfo && (
        <Form.Item
          className="employe-ev-form"
          name="areasOfImprovementComment"
          label="Area of Improvement"
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      )}
       {!selfEmployeeUserInfo && (
        <Form.Item
          className="employe-ev-form"
          name="otherRemarksIncrement"
          label="Remarks / recommendation (for increment or any) "
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      )}
    </>
  );
};

export default EmployeeEvaluationRating;
